import React, { useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import {
  BrowserRouter, createRoutesFromChildren,
  matchRoutes, useLocation, useNavigationType,
} from 'react-router-dom'
import { Provider } from 'react-redux'
import { init, reactRouterV6BrowserTracingIntegration, replayIntegration } from '@sentry/react'
import { StyledEngineProvider } from '@mui/material/styles'

import store from '@probatix/myprobatix/core/store'
import ModalRoot from 'core/shell/components/ModalRoot'
import { GIT_VERSION, SENTRY_DSN } from 'config/app'
import { worker } from './__mocks__/browser'

import App from './App'

if ('development' === process.env.NODE_ENV && 'false' !== process.env.VITE_ENABLE_MSW) {
  worker.start({
    onUnhandledRequest: 'bypass',
  })
}

/* eslint-disable no-console */
console.log(`%c Probatix Frontend App - ${GIT_VERSION}`, 'font-size: 0.875rem; font-weight: bold')
/* eslint-enable no-console */

const root = createRoot(document.getElementById('root')!)

if ('' !== process.env.SENTRY_DSN) {
  init({
    dsn: SENTRY_DSN,
    environment: 'prod',
    integrations: [
      reactRouterV6BrowserTracingIntegration({
        createRoutesFromChildren,
        matchRoutes,
        useEffect,
        useLocation,
        useNavigationType,
      }),
      replayIntegration(),
    ],
    release: 'frontend@' + GIT_VERSION,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    sendDefaultPii: true,
    tracesSampleRate: 1.0,
  })
}

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <StyledEngineProvider injectFirst>
          <ModalRoot />
          <App />
        </StyledEngineProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
)
